package com.neurobs.react

import org.scalajs.dom.html.Input
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useEffect
import slinky.web.html.input
import slinky.web.html._

class CheckboxWrapperReact(initialValue: Boolean) extends SingleValueControlWrapperReactBase[Boolean, Input](initialValue) {
	override protected def controlValue(control: Input): Boolean = control.checked
	override protected def setControlValue(control: Input, newValue: Boolean): Unit = { control.checked = newValue }
}

/**
 * This is an "uncontrolled" checkbox element with optional caption to the right.
 */
@react object Checkbox {
	case class Props
	(
		state: CheckboxControlWrapper,
		caption: Option[String] = None,
		disabled: Boolean = false,
		readOnly: Boolean = false,
		onChange: Option[() => Unit] = None
	)
	val component = FunctionalComponent[Props] { props =>
		val wrapper = props.state.asInstanceOf[CheckboxWrapperReact]
		useEffect( { () =>
			if (wrapper.ref.current != null) {
				wrapper.valueCache = wrapper.ref.current.checked
			}
		}, List(wrapper.ref))

		span(
			input(
				ref := wrapper.ref,
				`type` := "checkbox",
				defaultChecked := wrapper.valueCache,
				disabled := props.disabled,
				readOnly := props.readOnly,
				className := defaultCheckboxClass,
				onChange := props.onChange
			),
			span(style := StyleUtil.makeStyle(("marginLeft", "0.5em")))(props.caption)
		)
	}

	private val defaultCheckboxClass = "efactory-checkbox"
}
